import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface ReputationPillar {
  key: string;
  label: string;
  description: string;
  score: number;
}

export interface ReputationHint {
  pillar: string;
  label: string;
  description: string;
  current: number;
}

export interface ReputationData {
  computed: boolean;
  score: number;
  level: string;
  levelLabel: string;
  badgePublic: boolean;
  sampleSize: number;
  computedAt: string | null;
  pillars: ReputationPillar[];
  nextLevel: { level: string; label: string; pointsNeeded: number } | null;
  hints: ReputationHint[];
}

// Selo MustAuto Verificada — recalculado uma vez por dia no backend, então
// staleTime alto evita refetch desnecessário.
export function useReputation(workshopId: string | null) {
  return useQuery<ReputationData>({
    queryKey: ['reputation'],
    queryFn: async () => {
      const res = await api.get('/workshops/my/reputation');
      return res.data;
    },
    enabled: !!workshopId,
    staleTime: 5 * 60_000,
  });
}
